/**
 * Get badge text based on country and lead status
 * @param country - The country name (can be null/undefined)
 * @param isLead - Whether the user is a lead
 * @returns Badge text string ('UAE Lead', 'UAE User', 'Lead', or 'User')
 */
export const getUserBadgeText = (country: string | null | undefined, isLead: boolean): string => {
  const isUAE = country && (
    country.toLowerCase().includes('united arab emirates') || 
    country.toLowerCase().includes('uae')
  );
  
  if (isUAE) {
    return isLead ? 'UAE Lead' : 'UAE User';
  }
  return isLead ? 'Lead' : 'User';
};
